import { useTranslation } from "react-i18next";
import { Share2, Mail, MessageCircle, Facebook, Twitter } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { CopyField } from "./CopyField";
import { track } from "../lib/analytics";

export const publicLink = (slug) => `${window.location.origin}/m/${slug}`;

export const ShareDialog = ({ open, onOpenChange, slug, name }) => {
  const { t } = useTranslation();
  const url = publicLink(slug);
  const text = encodeURIComponent(name);
  const enc = encodeURIComponent(url);
  const targets = [
    { id: "whatsapp", icon: MessageCircle, href: `https://wa.me/?text=${text}%20${enc}` },
    { id: "facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc}` },
    { id: "x", icon: Twitter, href: `https://twitter.com/intent/tweet?url=${enc}&text=${text}` },
    { id: "email", icon: Mail, href: `mailto:?subject=${text}&body=${enc}` },
  ];
  const nativeShare = async () => {
    try {
      await navigator.share({ title: name, url });
      track("share");
    } catch {}
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg rounded-3xl" data-testid="share-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-normal">{t("share.title")}</DialogTitle>
          <DialogDescription>{t("share.lead")}</DialogDescription>
        </DialogHeader>
        <CopyField value={url} testId="share-link" />
        <div className="flex flex-wrap gap-2 pt-2">
          {navigator.share && (
            <button onClick={nativeShare} className="btn-primary !py-2.5 !px-5" data-testid="share-native-btn">
              <Share2 size={15} /> {t("share.native")}
            </button>
          )}
          {targets.map(({ id, icon: Icon, href }) => (
            <a key={id} href={href} target="_blank" rel="noopener noreferrer" onClick={() => track("share")} className="btn-ghost !py-2.5 !px-4" data-testid={`share-${id}-link`}>
              <Icon size={15} /> {t(`share.${id}`)}
            </a>
          ))}
        </div>
        <p className="text-xs text-[hsl(var(--muted-foreground))] pt-2">{t("share.note")}</p>
      </DialogContent>
    </Dialog>
  );
};
